// extracted by mini-css-extract-plugin
export default {"scroll":"ScrollBtn_scroll__cMtg0","link":"ScrollBtn_link__FfUPU","text":"ScrollBtn_text__QJaIn","icon":"ScrollBtn_icon__DSLJ+"};